import { chinaRegions, DEFAULT_APPLICATION_REGION } from './constant';

const CommonFunctions = {};

CommonFunctions.supportAndroidWebviewInterface = function (methodName) {
  return (
    typeof window.android !== 'undefined' &&
    typeof window.android[methodName] === 'function'
  );
};

CommonFunctions.isUndefined = function (object) {
  return (typeof object === 'undefined');
};

CommonFunctions.isUndefinedOrNull = function (object) {
  if (CommonFunctions.isUndefined(object) || CommonFunctions.isNull(object)) {
    return true;
  }
  return false;
};

CommonFunctions.isNull = function (object) {
  return (object === null);
};

CommonFunctions.isEmptyString = function (string) {
  return (string === '');
}

CommonFunctions.isFunction = function (object) {
  return object && typeof object === 'function';
};

CommonFunctions.noConsole = function () {};

CommonFunctions.debugLog = function (object) {
  if (
    process.env.NODE_ENV === 'production' ||
    process.env.NODE_ENV === 'staging'
  ) {
    CommonFunctions.noConsole();
  } else {
    console.log(object);
  }
};

CommonFunctions.filterNonNull = function (obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
};

CommonFunctions.stringifyRequestParams = function (originalParams) {
  const params = CommonFunctions.filterNonNull(originalParams);
  return Object.keys(params).map(function (key) {
    return CommonFunctions.isUndefinedOrNull(params[key]) ? '' : key + '=' + encodeURIComponent(params[key]);
  }).join('&');
};

CommonFunctions.buildRequestParamsString = function (params) {
  return '?' + CommonFunctions.stringifyRequestParams(params);
};

// CommonFunctions.extend = function (destination, sources) {
//   return _.extend.apply(undefined, arguments);
// };

CommonFunctions.formatDate = function (timestamp) {
  var d = new Date(timestamp * 1000), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
  if (month.length < 2){
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  return [year, month, day].join('-');
};

CommonFunctions.getServerBaseUrl = function (applicationRegion) {
  return (!CommonFunctions.isUndefinedOrNull(applicationRegion) && chinaRegions.includes(applicationRegion.toUpperCase())) ?
                    process.env.REACT_APP_API_URL_CN :
                    process.env.REACT_APP_API_URL;
};

CommonFunctions.getFilledParams = function (params = {}){
  let {applicationRegion, region, language} = params;
  const acceptLanguage = navigator.language;
  let _language = null, _region = null;
  const tags = acceptLanguage?.split('-') || [];
  if (tags.length > 2){
    _language = tags[0];
    _region = null;
  }
  else {
    _language = tags[0];
    _region = tags?.[1];
  }
  language =  language || _language;
  region =  region || _region;
  applicationRegion =  applicationRegion || region || DEFAULT_APPLICATION_REGION;
  return {...params, applicationRegion, region, language}
}

export default CommonFunctions;
